import type { ComponentProps } from "react";

import toast, { ToastBar, Toaster, ToasterProps } from "react-hot-toast";

import { XIcon } from "@lucide/icons";

import { cx, styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";

const ToastContainerStyled = styled.div`
  display: flex;
  align-items: center;

  &.is-clickable {
    cursor: pointer;
  }

  .icon-container {
    margin-right: 10px;
  }
  .info-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 19px;
    max-width: 270px;
    span {
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  }
  .meta {
    color: gray;
  }
`;

type ToastContainerProps = ComponentProps<typeof ToastContainerStyled>;

const ToastContainer = ({
  className,
  onClick,
  ...props
}: ToastContainerProps) => (
  <ToastContainerStyled
    className={cx(onClick && "is-clickable", className)}
    onClick={onClick}
    {...props}
  />
);

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 5px;
  right: 2.5px;
  cursor: pointer;
  color: gray;
`;

const CustomToaster = (props: ToasterProps) => (
  <Toaster {...props}>
    {(t) => (
      <ToastBar toast={t}>
        {({ icon, message }) => (
          <>
            {icon}
            {message}
            {t.type !== "loading" ? (
              <>
                <div style={{ width: 5 }} />
                <StyledIcon
                  onClick={() => toast.dismiss(t.id)}
                  icon={XIcon}
                  size="small"
                />
              </>
            ) : null}
          </>
        )}
      </ToastBar>
    )}
  </Toaster>
);

export { ToastContainer, CustomToaster as Toaster };
